import React, { useCallback, useEffect, useState } from 'react';
import { useItemsFilteredByDate } from '../../../../../data/hooks/datetime/useItemsFilteredByDate';
import { useI18n } from '../../../../../data/hooks/i18nHooks';
import { eventMomentFactory } from '../../../../../data/misc/eventMomentFactory';
import CurrentSelectedSlot from './CurrentSelectedSlot';
import SlotSelectionGrid from './SlotSelectionGrid';

function SlotSelection(props) {
    const { event, date, slot: selectedSlot, slots, onChange } = props,
        [expanded, setExpanded] = useState(!selectedSlot),
        isExpanded = expanded || !selectedSlot,
        visibleSlots = useItemsFilteredByDate(event, slots, date),
        i18n = useI18n();

    // if date changes, find a slot in the new date and same time (or unset it)
    useEffect(() => {
        if (selectedSlot && date && !eventMomentFactory(event, selectedSlot.start_local).isSame(date, 'day')) {
            const prevSlotStart = eventMomentFactory(event, selectedSlot.start_local),
                nextSlot = slots.find((s) => {
                    const nextSlotStart = eventMomentFactory(event, s.start_local);

                    return nextSlotStart.isSame(date, 'day') && nextSlotStart.get('hour') === prevSlotStart.get('hour') && nextSlotStart.get('minute') === prevSlotStart.get('minute');
                });

            onChange(nextSlot);
        }
    }, [date]);

    useEffect(() => {
        if (!selectedSlot) setExpanded(true);
    }, [selectedSlot]);

    const handleSlotSelection = useCallback(
        (slot) => {
            onChange(slot);
            if (slot) setExpanded(false);
        },
        [onChange]
    );

    if (!isExpanded) return <CurrentSelectedSlot event={event} slot={selectedSlot} onClick={() => setExpanded(true)} />;

    return <SlotSelectionGrid event={event} slot={selectedSlot} slots={visibleSlots} onChange={handleSlotSelection} />;
}

export default SlotSelection;
